import React, { useState, useMemo, useEffect } from "react";
import { Menu, X, ArrowRight, ArrowUpRight, Send, ChevronUp, MapPin, Mail } from "lucide-react";
import Cocr from "../imgs/cockrochjantaparty-logo.png"
/* ------------------------------------------------------------------ */
/*  DESIGN TOKENS                                                      */
/*  Case-file / protest-flyer system. Cockroach-toxic-green accent,   */
/*  carbon-copy paper cards, typewriter body type, stamped statuses.  */
/* ------------------------------------------------------------------ */
const SuccessAlert=()=>{
    return(<div><div class="container">
  <div class="rectangle">
    <div class="notification-text">
      <i class="material-icons">Success,</i>
      <span>&nbsp;&nbsp;the record has been saved</span>
    </div>
  </div>
</div></div>)
}
async function apiRequest(doprops,bodyprops,subBtnClick){
    const post=await fetch("https://script.google.com/macros/s/AKfycbzAsvF9MPBf4QQ9Mi_i16pM6lVUvXf9BF8f1lbe86z9GFCXxnkvLfBxfJJN4bVR0rAu1A/exec", {
  method: "POST",
   headers: { "Content-Type": "application/x-www-form-urlencoded" },
  body: new URLSearchParams({
    name: bodyprops.name,
    email: bodyprops.email,
    phone: bodyprops.phone,
    upi: "",
    id:bodyprops.id
  })
})
  .then(res => res.text())
  .then(data =>{ if (data==="OK"){
    localStorage.setItem("data",JSON.stringify(bodyprops))
    doprops(true)
  }})
  .catch(err => console.error(err));
subBtnClick(false);
}
const Member = ({ ShareVis, SetShare }) => {
   
    const [dataStore, setDataStore] = useState({
        name: '', email: '', phone: '', upi: '',id:Math.round(Math.round(Math.random()*50000000)/Math.round(Math.random()*70)),wining:1,progress:0
    });
     useEffect(()=>{
        const data=JSON.parse(localStorage.getItem('data'))
        if(data){
         setDataStore({name:data.name,email:data.email,phone:data.phone,id:data.id,wining:data.wining,progress:data.progress})}
     },[])
    const [inputBoxNo, setInputBoxNo] = useState(0);

    const fields = [
        { name: 'name', placeholder: "Enter your full name", type: "text", heading: 'Full Name', max: 40 },
        { name: 'email', placeholder: "Enter Your Email ID", type: "email", heading: 'Email ID', max: 50 },
        { name: 'phone', placeholder: "Enter 10 digit Mobile Number", type: "tel", heading: 'Phone Number', max: 10 },
    ];
const [btnSubmit,setBtnSubmit]=useState(false)
const subBtnClick=()=>{
    setBtnSubmit(true);
     apiRequest(SetShare,dataStore,setBtnSubmit);
}
    return (
        <div id='join' className='member-container'>
            {!ShareVis ? (
                <> 
                    <h3 className="join-title">Join CJP free!</h3>

                    {fields.map((field, i) => (
                        <div className='data-container' key={field.name}>
                            <p className='title-memeber-details'
                                style={{ color: inputBoxNo === i ? "#ff9800" : "#d32f2f" }}>
                                {field.heading} *
                            </p>
                            <input
                                required
                                name={field.name}
                                value={dataStore[field.name]}
                                onChange={(e) => setDataStore({ ...dataStore, [e.target.name]: e.target.value })}
                                type={field.type}
                                maxLength={field.max}
                                className='input-memeber-details'
                                placeholder={field.placeholder}
                                onFocus={() => setInputBoxNo(i)}
                            />
                        </div>
                    ))}

                    <button disabled={btnSubmit} className={!btnSubmit?'btn-body submit-btn':"btn-clcik submit-btn"} onClick={() =>  subBtnClick()}>
                        {!btnSubmit?"Submit ":"Verifying..."}
                    </button>
                </>
            ) : (
                <Share data={dataStore}  setDataStore={setDataStore} />
            )}

        </div>
    );
};

const Share = ({ data, setDataStore }) => {
    const [updateData,setUpdate]=useState(false);
    const [progress, setProgress] = useState(data.progress);
    const [lang, setLang] = useState('en');

    const languages = [
        { name: "हिंदी", code: "hi" },
        { name: "English", code: "en" },
        { name: "বাংলা", code: "ben" }
    ];

    const getMessage = (language, p) => {
        const baseLink = `${window.location.protocol}//${window.location.host}?ref=${encodeURIComponent(data.name)}&key=${data.id}`;

        const messages = {
            hi: `*कॉकरोच जनता पार्टी (CJP) का बड़ा ऐलान*
            \n\nअभी नीचे दिए लिंक पर क्लिक करके फॉर्म भरें \n${baseLink}\n\n> पहले आओ, पहले पाओ! बाद में मत कहना सूचना नहीं मिली `,

            en: `*COCKROACH JANATA PARTY (CJP) BIG ANNOUNCEMENT*\n\nClick the link below and fill the form \n${baseLink}\n\n> Hurry! First Come First Serve!`,

            ben: `*ককরোচ জনতা পার্টি (CJP) এর বড় ঘোষণা* \n\nনিচের লিঙ্কে ক্লিক করে ফর্ম পূরণ করুন \n${baseLink}\n\n> প্রথম আসুন, প্রথম পান!`
        };

        return messages[language] || messages.hi;
    };

    const handleShare = () => {
        const text = encodeURIComponent(getMessage(lang, progress + 1));
        window.open(`https://wa.me/?text=${text}`, "_blank");
        setProgress(prev => Math.min(prev + 1, 10));
        setUpdate(true)
    };
    useEffect(()=>{
       const localdata=JSON.parse(localStorage.getItem('data'))
       setProgress(localdata.progress)
if(updateData){setDataStore({...data,progress:progress,wining:(progress*10)-1})
        localStorage.setItem('data',JSON.stringify({...data,progress:progress,wining:(progress*10)-1}))
setUpdate(false)    
}
    },[progress])
    return (
        <div className="share-container">
            {<SuccessAlert/>}
            <h3>Share with Friend to become a active member!</h3>

            <div className="progress-bar">
                Your are : <strong>{data.wining}% active</strong>
            </div>

            <div className="language-selector">
                {languages.map(l => (
                    <button
                        key={l.code}
                        onClick={() => setLang(l.code)}
                        className={lang === l.code ? 'language-btn-selected' : 'language-btn-not-selected'}
                    >
                        {l.name}
                    </button>
                ))}
            </div>

            <textarea value={getMessage(lang, progress + 1)} readOnly rows={12} />

            <button className='btn-body' onClick={handleShare} style={{ width: '100%', marginTop: '15px', fontSize: '1.5rem' }}>
                📤 Share on WhatsApp
            </button>
        </div>
    );
};

const Donate = ({x}) => {
  useEffect(() => {
    if (!document.getElementById(`razorpay-script${x}`)) {
      const script = document.createElement("script");
      script.id = `razorpay-script${x}`; // ✅ unique ID
      script.src = "https://checkout.razorpay.com/v1/payment-button.js";
      script.setAttribute("data-payment_button_id", "pl_TGbIQTrATwSLlW");
      script.async = true;

      document.getElementById(`razorpay-container${x}`).appendChild(script);
    }
  }, []);

  return (
    <form className="btn" id={`razorpay-container${x}`}>
    </form>
  );
};
async function reqBlogger() {
  try {
    const res = await fetch("https://script.google.com/macros/s/AKfycbxFrnNgpdtK_FUIMLkuXXYUn55y28cV-emArw4cJ1jIGwVFUkgHeljH7ZR8MnGMYaRo/exec");
    const data = await res.json(); // 👈 JSON parse karega
    console.log(data);
  } catch (e) {
    console.error("Error:", e);
    
  }
}
const CJPacoring = () => {
    return (
        <div className="cjp-image-container">
            <img src={Cocr} width={360} height={230} style={{ margin: "30px 1px", borderRadius: 25 }} alt="CJP Theme" />
        </div>
    );
};

const Faqs = () => {
    const quest = [
        { Q: "❓ What's CJP's mood right now?", Ans: "👉 Answer: Satisfied, honestly. We're happy with the government's recent policies and clapping from the couch. The protest banner is in storage — we'll pull it out if we ever need it." },
        { Q: "❓ If the government keeps this pace up, what does CJP do?", Ans: "👉 Answer: We stay actively supportive — liking posts, sharing updates, and maybe even getting off the couch someday." },
        { Q: '❓ Can I still sign up for notifications?', Ans: '👉 Answer: Absolutely. Whenever a new announcement or scheme drops, we\'ll email you — so you can be happy along with us.' },
        { Q: '❓ What if a future policy doesn\'t land well?', Ans: "👉 Answer: Then we'll think about getting active again. For now, things are going fine." },
    ];

    return (
        <div id='cjp' className='faq-body'>
            {quest.map((v, i) => (
                <div key={i} className='faq-container'>
                    <div className='faq-title'>{v.Q}</div>
                    <div className='faq-ans'>{v.Ans}</div>
                </div>
            ))}
        </div>
    );
};


const GlobalStyle = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Anton&family=IBM+Plex+Mono:wght@400;500;600;700&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap');

    .cjp {
      --bg: #12140f;
      --bg-raise: #181c13;
      --paper: #efe8d2;
      --paper-dim: #e2dabf;
      --ink: #1b1f16;
      --toxic: #c6ff3d;
      --alert: #ff5a2b;
      --muted: #8b9184;
      --line: #33392a;
      --line-paper: #c9bf9c;
      font-family: 'IBM Plex Mono', monospace;
      background: var(--bg);
      color: var(--paper);
      background-image:
        radial-gradient(circle at 15% 8%, rgba(198,255,61,0.05), transparent 40%),
        radial-gradient(circle at 85% 70%, rgba(255,90,43,0.05), transparent 45%);
      min-height: 100vh;
      position: relative;
      overflow-x: hidden;
    }
    .cjp * { box-sizing: border-box; }
    .cjp .display {
      font-family: 'Anton', sans-serif;
      text-transform: uppercase;
      letter-spacing: 0.01em;
      line-height: 0.92;
    }
    .cjp .eyebrow {
      font-family: 'IBM Plex Mono', monospace;
      text-transform: uppercase;
      letter-spacing: 0.18em;
      font-size: 11px;
      color: var(--toxic);
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .cjp .eyebrow::before {
      content: "";
      width: 18px; height: 1px;
      background: var(--toxic);
    }
    .cjp .wrap {  margin: 0 auto; padding: 0 24px; }
    .cjp .grain {
      position: fixed; inset: 0; pointer-events: none; z-index: 50;
      opacity: 0.05; mix-blend-mode: overlay;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
    }
    .cjp button { font-family: inherit; cursor: pointer; }
    .cjp a { color: inherit; text-decoration: none; }

    /* NAV */
    .cjp .nav {
      position: sticky; top: 0; z-index: 40;
      background: rgba(18,20,15,0.9);
      backdrop-filter: blur(8px);
      border-bottom: 1px solid var(--line);
    }
      .wrap{
      padding: 20px !important}
    .cjp .nav-row { display: flex; align-items: center; justify-content: space-between; height: 68px; }
    .cjp .brand { display: flex; align-items: center; gap: 10px; }
    .cjp .brand-mark {
      width: 34px; height: 34px; border: 1.5px solid var(--toxic);
      display: flex; align-items: center; justify-content: center;
      color: var(--toxic); font-family: 'Anton', sans-serif; font-size: 14px;
      transform: rotate(-4deg);
    }
    .cjp .brand-text { font-family: 'Anton', sans-serif; font-size: 15px; letter-spacing: 0.03em; }
    .cjp .brand-text span { color: var(--muted); font-size: 10px; display: block; font-family: 'IBM Plex Mono'; letter-spacing: 0.1em; margin-top: 2px; }
    .cjp .nav-links { display: flex; gap: 28px; font-size: 12px; letter-spacing: 0.06em; text-transform: uppercase; }
    .cjp .nav-links a { color: var(--muted); transition: color .2s; position: relative; padding-bottom: 4px; }
    .cjp .nav-links a:hover { color: var(--paper); }
    .cjp .nav-cta { display: flex; gap: 10px; align-items: center; }
    .cjp .btn {
      font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase;
      padding: 10px 18px; border: 1px solid var(--line); background: transparent;
      color: var(--paper); display: inline-flex; align-items: center; gap: 6px;
      transition: all .15s;
    }
    .cjp .btn:hover { border-color: var(--toxic); color: var(--toxic); }
    .cjp .btn-solid {
      background: var(--toxic); color: var(--ink); border-color: var(--toxic); font-weight: 700;
    }
    .cjp .btn-solid:hover { background: var(--paper); border-color: var(--paper); color: var(--ink); }
    .cjp .burger { display: none; background: none; border: none; color: var(--paper); }
    .cjp .mobile-menu { display: none; flex-direction: column; gap: 4px; padding: 16px 0 24px; border-top: 1px solid var(--line); }
    .cjp .mobile-menu a { padding: 10px 4px; font-size: 13px; text-transform: uppercase; letter-spacing: .05em; color: var(--muted); border-bottom: 1px dashed var(--line); }

    /* HERO */
    .cjp .hero { padding: 35px 0 70px; position: relative; }
    .cjp .hero-tag {
      display: inline-flex; align-items: center; gap: 8px;
      border: 1px solid var(--line); padding: 6px 12px; font-size: 10px;
      letter-spacing: 0.12em; text-transform: uppercase; color: var(--muted); margin-bottom: 26px;
    }
    .cjp .hero-tag .dot { width: 6px; height: 6px; border-radius: 50%; background: var(--toxic); box-shadow: 0 0 8px var(--toxic); }
    .cjp .hero h1 { font-size: clamp(44px, 7vw, 88px); max-width: 900px; }
    .cjp .hero h1 em { font-style: normal; color: var(--toxic); }
    .cjp .hero-sub { color: var(--muted); max-width: 560px; font-size: 15px; line-height: 1.7; margin-top: 26px; }
    .cjp .hero-actions { display: flex; gap: 14px; margin-top: 34px; flex-wrap: wrap; }
    .cjp .stat-strip { display: grid; grid-template-columns: repeat(4,1fr); border-top: 1px solid var(--line); border-bottom: 1px solid var(--line); margin-top: 60px; }
    .cjp .stat-cell { padding: 22px 20px; border-right: 1px solid var(--line); }
    .cjp .stat-cell:last-child { border-right: none; }
    .cjp .stat-num { font-family: 'Anton'; font-size: 34px; color: var(--toxic); }
    .cjp .stat-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.1em; color: var(--muted); margin-top: 4px; }

    /* SECTION shell */
    .cjp .section { padding: 90px 0; border-bottom: 1px solid var(--line); }
    .cjp .section-head { display: flex; justify-content: space-between; align-items: flex-end; gap: 24px; margin-bottom: 44px; flex-wrap: wrap; }
    .cjp .section-title { font-size: clamp(30px, 4.4vw, 52px); margin-top: 10px; max-width: 620px; }
    .cjp .section-title em { color: var(--toxic); font-style: normal; }
    .cjp .section-desc { color: var(--muted); font-size: 13.5px; max-width: 320px; line-height: 1.7; }

    /* MOVEMENT card */
    .cjp .movement-card {
      border: 1px solid var(--line); background: var(--bg-raise);
      padding: 34px; display: grid; grid-template-columns: 1fr 240px; gap: 30px;
    }
    .cjp .movement-card h3 { font-size: 28px; margin: 12px 0 14px; }
    .cjp .movement-card p { color: var(--muted); font-size: 13.5px; line-height: 1.75; }
    .cjp .movement-meta { display: flex; gap: 22px; margin-top: 22px; }
    .cjp .movement-meta div { font-family: 'Anton'; font-size: 22px; color: var(--toxic); }
    .cjp .movement-meta span { display: block; font-family: 'IBM Plex Mono'; font-size: 9px; color: var(--muted); text-transform: uppercase; letter-spacing: .08em; margin-top: 2px; }
    .cjp .movement-side { border-left: 1px dashed var(--line); padding-left: 26px; display: flex; flex-direction: column; justify-content: space-between; }
    .cjp .progress-track { height: 6px; background: var(--line); position: relative; margin-top: 12px; }
    .cjp .progress-fill { position: absolute; inset: 0; background: var(--toxic); width: 78%; }

    /* VISION */
    .cjp .vision-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 50px; align-items: start; }
    .cjp .vision-grid p { color: var(--muted); font-size: 14.5px; line-height: 1.8; margin-bottom: 18px; }
    .cjp .vision-quote { font-family: 'Anton'; font-size: 26px; line-height: 1.25; color: var(--paper); }
    .cjp .live-stats { display: flex; flex-direction: column; gap: 0; border-top: 1px solid var(--line); margin-top: 26px; }
    .cjp .live-stat { display: flex; justify-content: space-between; padding: 16px 0; border-bottom: 1px solid var(--line); align-items: baseline; }
    .cjp .live-stat b { font-family: 'Anton'; font-size: 24px; color: var(--toxic); }
    .cjp .live-stat span { font-size: 11px; text-transform: uppercase; letter-spacing: .08em; color: var(--muted); }

    /* MANIFESTO */
    .cjp .demand-row { display: grid; grid-template-columns: 90px 1fr; border-top: 1px solid var(--line); }
    .cjp .demand-row:last-child { border-bottom: 1px solid var(--line); }
    .cjp .demand-num { font-family: 'Anton'; font-size: 15px; color: var(--muted); padding: 26px 0; }
    .cjp .demand-body { padding: 26px 0; border-left: 1px dashed var(--line); padding-left: 26px; font-size: 15px; line-height: 1.7; color: var(--paper-dim); }
    .cjp .demand-body b { color: var(--toxic); }
    .cjp .demand-row:hover .demand-num { color: var(--toxic); }

    /* ISSUES - complaint slips */
    .cjp .chip-row { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 34px; }
    .cjp .chip {
      font-size: 10.5px; text-transform: uppercase; letter-spacing: .06em;
      padding: 7px 13px; border: 1px solid var(--line); color: var(--muted); background: transparent;
    }
    .cjp .chip.active { background: var(--toxic); color: var(--ink); border-color: var(--toxic); font-weight: 700; }
    .cjp .issue-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
    .cjp .slip {
      background: var(--paper); color: var(--ink); padding: 22px 20px 20px;
      position: relative; border: 1px solid var(--line-paper);
      background-image: repeating-linear-gradient(to bottom, transparent, transparent 27px, rgba(0,0,0,0.035) 28px);
    }
    .cjp .slip::before {
      content: ""; position: absolute; top: -1px; left: 16px; right: 16px; height: 1px;
      background: repeating-linear-gradient(to right, var(--line-paper) 0 6px, transparent 6px 12px);
    }
    .cjp .slip-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
    .cjp .slip-cat { font-size: 9.5px; text-transform: uppercase; letter-spacing: .08em; color: #6b6249; }
    .cjp .slip-score { font-family: 'Anton'; font-size: 13px; }
    .cjp .slip-title { font-family: 'IBM Plex Sans'; font-weight: 700; font-size: 15px; margin-bottom: 8px; line-height: 1.35; }
    .cjp .slip-body { font-size: 12px; color: #4a4738; line-height: 1.6; margin-bottom: 16px; min-height: 40px; }
    .cjp .slip-foot { display: flex; justify-content: space-between; align-items: center; font-size: 10.5px; color: #736b52; border-top: 1px dashed var(--line-paper); padding-top: 12px; }
    .cjp .stamp {
      position: absolute; top: 16px; right: 16px;
      border: 1.5px solid var(--alert); color: var(--alert);
      font-family: 'Anton'; font-size: 9px; letter-spacing: .06em;
      padding: 3px 8px; transform: rotate(8deg); opacity: .85;
    }

    /* ELIGIBILITY */
    .cjp .req-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px; background: var(--line); border: 1px solid var(--line); }
    .cjp .req-cell { background: var(--bg); padding: 30px 24px; }
    .cjp .req-cell .num { font-family: 'IBM Plex Mono'; font-size: 10px; color: var(--muted); letter-spacing: .1em; }
    .cjp .req-cell h4 { font-family: 'Anton'; font-size: 20px; margin: 14px 0 10px; color: var(--toxic); }
    .cjp .req-cell p { font-size: 12.5px; color: var(--muted); line-height: 1.6; }

    /* CTA banner */
    .cjp .cta-banner {
      background: var(--toxic); color: var(--ink);
      padding: 60px 0; text-align: center; border-bottom: 1px solid var(--line);
    }
    .cjp .cta-banner h2 { font-size: clamp(30px,5vw,56px); }
    .cjp .cta-banner .btn { background: var(--ink); color: var(--toxic); border-color: var(--ink); margin-top: 26px; }
    .cjp .cta-banner .btn:hover { background: transparent; color: var(--ink); }

    /* CONTACT */
    .cjp .contact-grid { display: grid; grid-template-columns: 1fr 1.3fr; gap: 60px; }
    .cjp .contact-item { display: flex; gap: 14px; padding: 18px 0; border-bottom: 1px solid var(--line); }
    .cjp .contact-item .ic { color: var(--toxic); flex-shrink: 0; margin-top: 2px; }
    .cjp .contact-item b { display: block; font-size: 12px; text-transform: uppercase; letter-spacing: .06em; color: var(--muted); margin-bottom: 4px; }
    .cjp .field { width: 100%;     border-radius: 11px; border: none; border-bottom: 1px solid var(--line); color: var(--paper); padding: 12px 2px; font-family: 'IBM Plex Mono'; font-size: 13px; margin-bottom: 22px; outline: none; }
    .cjp .field:focus { border-color: var(--toxic); }
    .cjp .field::placeholder { color: var(--muted); }
    .cjp textarea.field { resize: vertical; min-height: 90px; }

    /* FOOTER */
    .cjp .footer { padding: 60px 0 30px; }
    .cjp .footer-grid { display: grid; grid-template-columns: 1.6fr 1fr 1fr 1fr; gap: 40px; }
    .cjp .footer h5 { font-size: 11px; text-transform: uppercase; letter-spacing: .1em; color: var(--muted); margin-bottom: 16px; }
    .cjp .footer ul { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 10px; }
    .cjp .footer ul a { font-size: 13px; color: var(--paper-dim); }
    .cjp .footer ul a:hover { color: var(--toxic); }
    .cjp .footer-bottom { display: flex; justify-content: space-between; align-items: center; margin-top: 50px; padding-top: 20px; border-top: 1px solid var(--line); font-size: 11px; color: var(--muted); flex-wrap: wrap; gap: 12px; }
    .cjp .footer-bottom .satire { color: var(--alert); }
    .cjp .socials { display: flex; gap: 10px; }
    .cjp .socials a { width: 34px; height: 34px; border: 1px solid var(--line); display: flex; align-items: center; justify-content: center; }
    .cjp .socials a:hover { border-color: var(--toxic); color: var(--toxic); }

    @media (max-width: 860px) {
      .cjp .nav-links, .cjp .nav-cta .btn:first-child { display: none; }
      .cjp .burger { display: block; }
      .cjp .mobile-menu.open { display: flex; }
      .cjp .stat-strip { grid-template-columns: repeat(2,1fr); }
      .cjp .stat-cell:nth-child(2) { border-right: none; }
      .cjp .vision-grid, .cjp .contact-grid, .cjp .movement-card { grid-template-columns: 1fr; }
      .cjp .movement-side { border-left: none; padding-left: 0; border-top: 1px dashed var(--line); padding-top: 20px; margin-top: 10px; }
      .cjp .req-grid, .cjp .issue-grid { grid-template-columns: 1fr 1fr; }
      .cjp .footer-grid { grid-template-columns: 1fr 1fr; }
    }
    @media (max-width: 560px) {
      .cjp .req-grid, .cjp .issue-grid, .cjp .footer-grid { grid-template-columns: 1fr; }
    }
  `}</style>
);

/* ------------------------------------------------------------------ */
/*  DATA                                                               */
/* ------------------------------------------------------------------ */
const DEMANDS = [
    { n: "01", text: "For now, we are satisfied; our focus is only on removing the BJP, so support us to remove the BJP." },
  { n: "02", text: "We are satisfied for now; if we keep protesting repeatedly, people won't come and it can send a negative message." },
  { n: "03", text: "No paper has been leaked in Punjab, this is just a move by the BJP guys, we only steal alcohol." },
   { n: "04", text: "Our ultimate goal is to remove the BJP from power and make our founders' father the Prime Minister." },
   {n:"05",text :"Anyone can join our protest and we will work to keep them safe"},
];

const CATEGORIES = ["All", "Governance", "Education", "Welfare", "Employment", "Infrastructure", "Reforms"];

const ISSUES = [
  { cat: "Governance", score: "10/10", title: "Policy delivery, on schedule", body: "Announcements are actually showing up as implementation. We noticed. We approve.", user: "R. Tharun", time: "1m ago", up: 2 },
  { cat: "Employment", score: "9/10", title: "Job drives worth watching", body: "Recent employment initiatives are giving us fewer reasons to stay unemployed by choice.", user: "S. Enbaraj", time: "18m ago", up: 3 },
  { cat: "Education", score: "8/10", title: "Exam system feels sturdier", body: "Fewer leaks, more accountability. The bar was low, but it cleared it.", user: "R. Rizal", time: "31m ago", up: 2 },
  { cat: "Welfare", score: "9/10", title: "Welfare schemes reaching people", body: "Ground reports match the press release for once. We'll take it.", user: "Janani K.", time: "35m ago", up: 5 },
  { cat: "Infrastructure", score: "9/10", title: "Infra projects on track", body: "Roads, rail, and rollouts happening faster than our excuses to skip the gym.", user: "Ketki S.", time: "2h ago", up: 33 },
  { cat: "Reforms", score: "10/10", title: "Reform pace holding steady", body: "If this keeps up, we might have to update our whole personality.", user: "Tanvi V.", time: "2h ago", up: 72 },
];

const REQS = [
  { n: "REQ / 01", title: "Unemployed", body: "By force, by choice, or by principle. We don't ask which." },
  { n: "REQ / 02", title: "Lazy", body: "Physically only. The brain is welcome to keep spiralling." },
  { n: "REQ / 03", title: "Chronically online", body: "Minimum 11 hours a day, bathroom breaks included." },
  { n: "REQ / 04", title: "Can cheer professionally", body: "Ready to go from couch-potato to active supporter the moment it's warranted." },
];

/* ------------------------------------------------------------------ */
/*  COMPONENTS                                                         */
/* ------------------------------------------------------------------ */
function Navbar() {
  const [open, setOpen] = useState(false);
  const links = ["Home", "Movements", "Manifesto", "Issues", "Eligibility", "Contact"];
  return (
    <header className="nav">
      <div className="wrap nav-row">
        <div className="brand">
          <div className="brand-mark"><img alt={Cocr} src={Cocr} width={25} height={25}/></div>
          <div className="brand-text">COCKROACH JANTA PARTY<span>Est. 2026 · Currently Satisfied</span></div>
        </div>
        <nav className="nav-links">
          {links.map(l => <a key={l} href={`#${l.toLowerCase()}`}>{l}</a>)}
        </nav>
        <div className="nav-cta">
             <Donate x={0}/>
          <a className="btn btn-solid" href="#join">Join Party <ArrowUpRight size={13}/></a>
          
          <button className="burger" onClick={() => setOpen(o => !o)}>{open ? <X size={22}/> : <Menu size={22}/>}</button>
        </div>
      </div>
      <div className={`wrap mobile-menu ${open ? "open" : ""}`}>
        {links.map(l => <a key={l} href={`#${l.toLowerCase()}`} onClick={() => setOpen(false)}>{l}</a>)}
      </div>
    </header>
  );
}

function Hero() {
         const [ShowShareContainer, SetVisibleShareContainer] = useState(localStorage.getItem('data')?true:false);

  return (
    <section className="hero wrap" id="home">
        <div style={{display:'ruby'}}> <div><div className="hero-tag"><span className="dot"/> Official movement · Currently happy since yesterday</div>
      <h1 className="display">Voice of the<br/>Lazy &amp; <em>Satisfied.</em></h1>
      <p className="hero-sub">
      The papers of Punjab and Jharkhand were also leaked by the central government... They are trying to trap us.. the people who cheated in Punjab and Jharkhand are those from the BJP..</p>
   <div className="hero-actions">
        <a className="btn btn-solid" href="#issues">Browse Wins <ArrowRight size={13}/></a>
        <a className="btn" href="#manifesto">Read the Manifesto</a>
              <Donate x={1}/>
      </div></div>
        <Member  ShareVis={ShowShareContainer} SetShare={SetVisibleShareContainer} /></div>
  
      <div className="stat-strip">
        <div className="stat-cell"><div className="stat-num">05</div><div className="stat-label">Commitments</div></div>
        <div className="stat-cell"><div className="stat-num">14,035</div><div className="stat-label">Citizens</div></div>
        <div className="stat-cell"><div className="stat-num">3,842</div><div className="stat-label">Wins Filed</div></div>
        <div className="stat-cell"><div className="stat-num">∞</div><div className="stat-label">Readiness</div></div>
      </div>
    </section>
  );
}

function MovementSection() {
  return (
    <section className="section wrap" id="movements">
      <div className="eyebrow">The Movement Platform</div>
      <h2 className="section-title display">Join the applause.<br/><em>Stay on standby.</em></h2>
      <div className="movement-card">
        <div>
          <span className="eyebrow" style={{marginBottom: 0}}>Phase One</span>
          <h3 className="display">The People Are Watching, Approvingly</h3>
          <p>
            Phase One is about building awareness, identity, and unity among citizens who
            think the current run of policy is actually landing. It isn't about a party symbol — it's about
            staying informed, staying ready, and a national youth movement that shows up when it matters. 🤣🤣
          </p>
          <div className="movement-meta">
            <div>425<span>Supporters</span></div>
            <div>3<span>Tasks</span></div>
            <div>334<span>Contributions</span></div>
          </div>
        </div>
        <div className="movement-side">
          <div>
            <span className="eyebrow" style={{marginBottom: 0}}>Progress</span>
            <div className="progress-track"><div className="progress-fill"/></div>
          </div>
          <a className="btn" href="#movement" style={{justifyContent: "center", marginTop: 20}}>View Movement <ArrowUpRight size={13}/></a>
        </div>
      </div>
    </section>
  );
}

function VisionSection() {
  return (
    <section className="section wrap" id="vision">
      <div className="vision-grid">
        <div>
          <div className="eyebrow">Chapter One</div>
          <h2 className="section-title display" style={{marginBottom: 24}}>Our movement's <em>vision.</em></h2>
          <p>
            We're not here to launch another relief fund or a taxpayer-funded holiday.
            We're here to say, plainly and repeatedly: the current run of policies is working,
            and we're watching closely to make sure it stays that way.
          </p>
          <p className="vision-quote">
            "Build a party for the young people who keep getting called lazy,
            chronically online, and — most recently — cockroaches. Happy ones, for now."
          </p>
        </div>
        <div>
          <div className="eyebrow">Live Stats</div>
          <div className="live-stats">
            <div className="live-stat"><span>Issues raised by citizens</span><b>3,842</b></div>
            <div className="live-stat"><span>Cockroaches united</span><b>14,035</b></div>
            <div className="live-stat"><span>Comments &amp; discussions</span><b>151</b></div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ManifestoSection() {
  return (
    <section className="section wrap" id="manifesto">
      <div className="section-head">
        <div>
          <div className="eyebrow">The Five Commitments</div>
          <h2 className="section-title display">Official <em>manifesto.</em></h2>
        </div>
        <p className="section-desc">Read it once. Read it twice. Then send it to someone who needs cheering up.</p>
      </div>
      <div>
        {DEMANDS.map(d => (
          <div className="demand-row" key={d.n}>
            <div className="demand-num">{d.n}</div>
            <div className="demand-body">{d.text}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

function IssuesSection() {
  const [active, setActive] = useState("All");
  const filtered = useMemo(
    () => active === "All" ? ISSUES : ISSUES.filter(i => i.cat === active),
    [active]
  );
  return (
    <section className="section wrap" id="issues">
      <div className="section-head">
        <div>
          <div className="eyebrow">Case Files</div>
          <h2 className="section-title display">Latest <em>wins.</em></h2>
        </div>
        <p className="section-desc">Every entry here is something we're genuinely happy about. Browse, upvote, or file your own.</p>
      </div>
      <div className="chip-row">
        {CATEGORIES.map(c => (
          <button key={c} className={`chip ${active === c ? "active" : ""}`} onClick={() => setActive(c)}>{c}</button>
        ))}
      </div>
      <div className="issue-grid">
        {filtered.map((iss, idx) => (
          <div className="slip" key={idx}>
            <span className="stamp">Approved</span>
            <div className="slip-top">
              <span className="slip-cat">{iss.cat}</span>
              <span className="slip-score">{iss.score}</span>
            </div>
            <div className="slip-title">{iss.title}</div>
            <div className="slip-body">{iss.body}</div>
            <div className="slip-foot">
              <span>{iss.user} · {iss.time}</span>
              <span>▲ {iss.up}</span>
            </div>
          </div>
        ))}
      </div>
      <a className="btn" href="#all-issues" style={{marginTop: 34}}>View All Wins <ArrowRight size={13}/></a>
    </section>
  );
}

function EligibilitySection() {
  return (
    <section className="section wrap" id="eligibility">
      <div className="section-head">
        <div>
          <div className="eyebrow">Membership</div>
          <h2 className="section-title display">Are you eligible <em>to join?</em></h2>
        </div>
        <p className="section-desc">No religion, caste, or gender checks. We do, however, have four standards.</p>
      </div>
      <div className="req-grid">
        {REQS.map(r => (
          <div className="req-cell" key={r.n}>
            <div className="num">{r.n}</div>
            <h4>{r.title}</h4>
            <p>{r.body}</p>
          </div>
        ))}
      </div>
      <p style={{color: "var(--muted)", fontSize: 12.5, marginTop: 24}}>
        Membership is free, lifelong, and revocable only by you. No fees. No selfies with a leader.
      </p>
    </section>
  );
}

function CtaBanner() {
  return (
    <section className="cta-banner">
      <div className="wrap">
        <div className="eyebrow" style={{color: "var(--ink)", justifyContent: "center"}}>
          <span style={{opacity: 0}}>·</span>Happy now. Ready for whatever's next.
        </div>
        <h2 className="display" style={{marginTop: 14}}>Stronger together.</h2>
        <a className="btn" href="#join">Get Notified <ArrowRight size={13}/></a>
      </div>
    </section>
  );
}

function ContactSection() {
  return (
    <section className="section wrap" id="contact">
      <div className="section-head">
        <div>
          <div className="eyebrow">Get In Touch</div>
          <h2 className="section-title display">Connect <em>with us.</em></h2>
        </div>
        <p className="section-desc">Want to join, volunteer, complain, or send a meme? We read everything.</p>
      </div>
      <div className="contact-grid">
        <div>
          <div className="contact-item">
            <Mail size={17} className="ic"/>
            <div><b>Email</b>support@chaina.org</div>
          </div>
          <div className="contact-item">
            <MapPin size={17} className="ic"/>
            <div><b>Headquarters</b>Wherever the wifi works.</div>
          </div>
          <div className="contact-item">
            <Send size={17} className="ic"/>
            <div><b>Founded</b>2026 · A movement by the people</div>
          </div>
        </div>
        <form style={{    border: '1px solid', padding: 20}} onSubmit={e => e.preventDefault()}>
          <input className="field" placeholder="Your Name" />
          <input className="field" placeholder="Email" type="email" />
          <input className="field" placeholder="Subject" />
          <textarea className="field" placeholder="Message" rows={4} />
          <button type="submit" className="btn btn-solid">Send Message <ArrowRight size={13}/></button>
        </form>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="footer wrap">
      <div className="footer-grid">
        <div>
          <div className="brand" style={{marginBottom: 14}}>
            <div className="brand-mark"><img alt={Cocr} src={Cocr} width={25} height={25}/></div>
            <div className="brand-text">COCKROACH<br/>JANTA PARTY</div>
          </div>
          <p style={{fontSize: 12.5, color: "var(--muted)", maxWidth: 240, lineHeight: 1.6}}>
            A political party for the lazy, the unemployed, and the currently satisfied.
            Headquartered wherever the wifi works.
          </p>
        </div>
        <div>
          <h5>The Party</h5>
          <ul><li><a href="#vision">Vision</a></li><li><a href="#manifesto">Manifesto</a></li><li><a href="#about">About</a></li></ul>
        </div>
        <div>
          <h5>Get Involved</h5>
          <ul><li><a href="#eligibility">Eligibility</a></li><li><a href="#join">Get Notified</a></li><li><a href="#issues">Browse Wins</a></li></ul>
        </div>
        <div>
          <h5>Follow</h5>
          <div className="socials">
            
            <a href="#" aria-label="Instagram"><X size={15}/></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Cockroach Janta Party · All rants reserved. <span className="satire">⚠ A work of satire</span></span>
        <button className="btn" onClick={() => window.scrollTo({top:0, behavior:"smooth"})}>Top <ChevronUp size={13}/></button>
      </div>
    </footer>
  );
}

/* ------------------------------------------------------------------ */
/*  APP                                                                 */
/* ------------------------------------------------------------------ */
export default function Home2() {
  return (
    <div className="cjp">
      <GlobalStyle />
      <div className="grain" />
      <Navbar />
      
      <Hero />
     
      <MovementSection />
      <VisionSection />
      <ManifestoSection />
      <IssuesSection />
      <EligibilitySection />
      <CtaBanner />
      <ContactSection />
      <Footer />
    </div>
  );
}